module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa4 bl b-theme bw3 br20 bg-white hover-lift shadow-theme"
  }, [_c('div', {
    staticClass: "f4"
  }, [_c('img', {
    staticClass: "dib h2 v-mid mr2",
    attrs: {
      "src": _vm.icon,
      "alt": ""
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "color-theme no-underline",
    attrs: {
      "to": ("/devices/" + (this.id))
    }
  }, [_vm._v(_vm._s(_vm.nickname))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mv3"
  }, [_c('span', {
    staticClass: "v-mid ttc"
  }, [_vm._v(_vm._s(_vm.brand) + " - " + _vm._s(_vm.model.trim() === '' ? _vm.type : _vm.model))])]), _vm._v(" "), (_vm.serial) ? _c('div', [_c('div', {
    staticClass: "f6 gray"
  }, [_vm._v("\n      Serial Number:\n    ")]), _vm._v("\n    " + _vm._s(_vm.serial) + "\n  ")]) : _c('div', {
    staticClass: "f6 gray"
  }, [_vm._v("\n    No serial number\n  ")]), _vm._v(" "), (_vm.featureFlagMultiLossTypeActive) ? _c('div', {
    staticClass: "mv3"
  }, [_c('div', {
    staticClass: "f6 gray"
  }, [_vm._v("\n        Loss Types\n      ")]), _vm._v(" "), _vm._l((_vm.lossTypes), function(loss_type) {
    return _c('small', {
      key: loss_type.id,
      staticClass: "loss-type-label"
    }, [(loss_type.name == 'Other') ? _c('span', [_vm._v(_vm._s(loss_type.loss_type_category) + " - ")]) : _vm._e(), _vm._v(_vm._s(loss_type.name) + "\n    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.featureFlagMultiLossTypeActive) ? _c('div', {
    staticClass: "mv3"
  }, [_c('div', {
    staticClass: "f6 gray"
  }, [_vm._v("\n        Previous Damage\n      ")]), _vm._v("\n      " + _vm._s(_vm.knownDamage) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09df63de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClaimDeviceTile.vue
// module id = 1402
// module chunks = 0